(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_d5027a3"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fitz-video-hero')) {
    customElements.define('fitz-video-hero', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.videos = Array.from(this.querySelectorAll('video'));
        this.button = this.querySelector('[data-playback]');
        if (!this.videos.length || !this.button) return;
        this.media = window.matchMedia('(max-width: 749px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;
        this.button.hidden = false;
        this.videos.forEach(video => {
          video.muted = true;
          video.addEventListener('play', () => this.updateButton(), options);
          video.addEventListener('pause', () => this.updateButton(), options);
        });
        this.button.addEventListener('click', () => {
          const video = this.activeVideo();
          if (video.paused) {
            this.userPaused = false;
            video.play().catch(() => this.updateButton());
          } else {
            this.userPaused = true;
            video.pause();
          }
        }, options);
        this.media.addEventListener('change', () => this.syncPlayback(), options);
        this.reducedMotion.addEventListener('change', () => this.syncPlayback(), options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.syncPlayback();
      }
      activeVideo() { return this.videos[this.media.matches ? 1 : 0] || this.videos[0]; }
      updateButton() {
        const paused = this.activeVideo().paused;
        this.button.dataset.paused = String(paused);
        this.button.setAttribute('aria-label', paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
      }
      syncPlayback() {
        const active = this.activeVideo();
        this.videos.forEach(video => {
          if (video !== active || document.hidden || this.userPaused || this.reducedMotion.matches) video.pause();
          else video.play().catch(() => this.updateButton());
        });
        this.updateButton();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.videos?.forEach(video => video.pause());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
